import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from 'styleguide';

function Rejected(props) {
  const ratio = 44 / 45;

  return (
    <svg width={props.size} height={Math.floor(props.size * ratio)} viewBox="0 0 45 44" xmlns="http://www.w3.org/2000/svg">
      <path d="M42.604 21.898C42.604 10.908 33.696 2 22.706 2S2.808 10.91 2.808 21.898c0 10.99 8.908 19.898 19.898 19.898s19.898-8.908 19.898-19.898zm2 0c0 12.094-9.804 21.898-21.898 21.898S.808 33.992.808 21.898 10.612 0 22.706 0s21.898 9.804 21.898 21.898zm-29.166-8.682l-1.414 1.414 8.797 8.797 8.796-8.797-1.414-1.414-7.38 7.383-7.384-7.384zm14.764 17.58l1.414-1.413-8.795-8.797-8.796 8.797 1.414 1.414 7.383-7.383 7.382 7.383z" fillRule="nonzero" fill={props.color} />
    </svg>
  );
}

Rejected.defaultProps = {
  color: `${COLORS.error}`,
  size: 45,
};

Rejected.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

export default Rejected;
